'use client'

import React, { useState } from 'react'

import { Item } from 'appTypes/mapper'
import { handleProductImageFallback } from 'utils/imageFallback'

type Props = {
  product: Item | undefined
}

const ProductImageView = ({ product }: Props) => {
  const sortedImages =
    product?.products[0] && [...(product?.products[0].images ?? [])].sort((a, b): number => a.id - b.id)

  const [currentMediumUrl, setCurrentMediumUrl] = useState<string | undefined>(sortedImages?.[0]?.mediumUrl ?? '')
  const [mediumErrorLevel, setMediumErrorLevel] = useState(0)

  const handleMediumImageErrorFallback = (index: number) => {
    if (!sortedImages || !sortedImages[index]) {
      return
    }

    handleProductImageFallback(
      sortedImages[index],
      currentMediumUrl,
      mediumErrorLevel,
      setCurrentMediumUrl,
      setMediumErrorLevel,
    )
  }

  return (
    <img
      loading="lazy"
      src={currentMediumUrl}
      onError={() => handleMediumImageErrorFallback(0)}
      alt=""
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'fill' }}
    />
  )
}

export default ProductImageView
